module.exports = __webpack_public_path__ + "login_register_bg.490b841b8403cbff1e9b.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/soccer/samples/login_register_bg.jpg
// module id = ../../../../../src/assets/images/soccer/samples/login_register_bg.jpg
// module chunks = styles